import { Link, Navigate, useParams } from 'react-router-dom';
import { AppIcon } from '../components/AppIcon';
import { getAppBySlug } from '../data/apps';

export function AppDetailPage() {
  const { appSlug } = useParams();
  const app = getAppBySlug(appSlug);

  if (!app) {
    return <Navigate to="/apps" replace />;
  }

  return (
    <section className="section-page app-detail-page">
      <div className="app-detail-hero">
        <div>
          <p className="eyebrow">{app.status}</p>
          <h1>{app.name}</h1>
          <p>{app.tagline}</p>
          <div className="hero-actions">
            {app.playUrl ? <a className="primary-action" href={app.playUrl} target="_blank" rel="noreferrer">Open on Google Play</a> : null}
            <AppLegalLink app={app} type="privacy" label="Privacy Policy" />
            <AppLegalLink app={app} type="terms" label="Terms" />
          </div>
        </div>
        <AppIcon app={app} size="large" />
      </div>
      <div className="roadmap-grid">
        {app.highlights.map((highlight) => (
          <div key={highlight}>
            <strong>{highlight}</strong>
            <p>Part of the 2xHappiness app family, with product-specific policy and terms pages.</p>
          </div>
        ))}
      </div>
    </section>
  );
}

function AppLegalLink({ app, type, label }) {
  if (app.legalMode === 'external') {
    return (
      <a className="secondary-action" href={type === 'privacy' ? app.privacyUrl : app.termsUrl}>{label}</a>
    );
  }

  return (
    <Link className="secondary-action" to={`/apps/${app.slug}/${type}`}>{label}</Link>
  );
}
